import { CarouselDots, Carousel, NoDigitalCalendar, useNoDigitalSlots } from '@shared/ui'

import { ScheduleGrid } from '../schedule-grid/schedule-grid'

interface CarouselAgendaProps {
  noDigital: boolean
  schedules: any[]
  dateSelected: Date | null
  previousDate: string | Date | null | undefined
  fieldName: string
  dateBannerClasses?: string
  isMod: boolean
  modifyDate: Date | null
  setModifyDate: any
  isSr: boolean
  policyId?: string
}

export const CarouselAgenda: React.FC<CarouselAgendaProps> = ({
  noDigital,
  schedules,
  dateSelected,
  previousDate,
  fieldName,
  isMod,
  modifyDate,
  setModifyDate,
  isSr,
  policyId = '',
}) => {
  const { slots, selectedSlot, setSelectedSlot, loading, error, errorType } = useNoDigitalSlots({ 
    policyId, 
    enabled: noDigital 
  });
  const groupSchedules = () => {
    if (!noDigital) {
      // Group by complete weeks (7 days) instead of arbitrary number
      const groupedByWeeks = []
      
      // First, group schedules by date
      const schedulesByDate = schedules.reduce((acc, schedule) => {
        const date = new Date(schedule.slotDate).toISOString().split('T')[0]
        if (!acc[date]) {
          acc[date] = []
        }
        acc[date].push(schedule)
        return acc
      }, {})
      
      // Get sorted dates
      const sortedDates = Object.keys(schedulesByDate).sort()
      
      // Group dates into weeks (7 consecutive days)
      for (let i = 0; i < sortedDates.length; i += 7) {
        const weekDates = sortedDates.slice(i, i + 7)
        const weekSchedules = weekDates.flatMap(date => schedulesByDate[date])
        if (weekSchedules.length > 0) {
          groupedByWeeks.push(weekSchedules)
        }
      }
      
      return groupedByWeeks
    } else {
      const groupedBySlots = []
      let slot = []
      for (let i = 0; i < schedules.length; i++) {
        slot.push(schedules[i])
        if (slot.length === 14) {
          groupedBySlots.push(slot)
          slot = []
        }
      }
      if (slot.length > 0) {
        groupedBySlots.push(slot)
      }
      return groupedBySlots
    }
  }

  const groupedSchedules = groupSchedules()

 

  if (noDigital) {
    return (
      <NoDigitalCalendar 
        slots={slots}
        selectedSlot={selectedSlot}
        onSlotSelect={setSelectedSlot}
        loading={loading}
        error={error}
        errorType={errorType}
      />
    )
  }

  return (
    <Carousel DotsComponent={CarouselDots}>
      {groupedSchedules.map((group, index) => (
        <ScheduleGrid
          key={index}
          noDigital={noDigital}
          schedules={group}
          fieldName={fieldName}
          watchValue={previousDate}
          isMod={isMod}
          modifyDate={modifyDate}
          setModifyDate={setModifyDate}
        />
      ))}
    </Carousel>
  )
}
